import { useState } from "react";
import { Link } from "react-scroll";
import { RiMenu4Line, RiCloseFill } from "react-icons/ri";

const Navigation = () => {
  const [isNavOpen, setNavOpen] = useState(false);

  const toggleNav = () => {
    if (window.innerWidth >= 600) return;
    setNavOpen((prevState) => !prevState);
  };

  return (
    <nav className="navigation">
      <div className="section">
        <div className="navigation__items">
          <Link
            to="home"
            smooth={true}
            onClick={toggleNav}
            className="navigation__link"
          >
            Ghulam
          </Link>
        </div>
        <div className="navigation__humburger-btn" onClick={toggleNav}>
          {isNavOpen ? <RiCloseFill /> : <RiMenu4Line />}
        </div>
        <div
          className={`navigation__items navigation__phone ${
            isNavOpen && "navigation__phone--active"
          }`}
        >
          <ul className="navigation__list">
            <li className="navigation__item">
              <Link
                to="home"
                smooth={true}
                onClick={toggleNav}
                className="navigation__link"
              >
                Home
              </Link>
            </li>
            <li className="navigation__item">
              <Link
                to="project"
                smooth={true}
                onClick={toggleNav}
                className="navigation__link"
              >
                Works
              </Link>
            </li>
            <li className="navigation__item">
              <Link
                to="skills"
                smooth={true}
                onClick={toggleNav}
                className="navigation__link"
              >
                Skills
              </Link>
            </li>
            <li className="navigation__item">
              <Link
                to="contacts"
                smooth={true}
                onClick={toggleNav}
                className="navigation__link"
              >
                Contacts
              </Link>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default Navigation;
